export enum SignUpType {
    /** Create new partial profile */
    PARTIAL = 'partial',

    /** Update partial profile with password to become a complete online user */
    ONLINE = 'online',

    /** Create new complete online user, e.g. register from IAM page */
    COMPLETE = 'complete'
}
